// extracted by mini-css-extract-plugin
module.exports = {"loaderView":"FetchLoader_loaderView__qU04z","loader":"FetchLoader_loader__7oogX"};